/* eslint-disable react/jsx-no-bind */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable react/prop-types */
import React from 'react';

import Select from 'react-dropdown-select';

const GenresDropDownComponent = ({ options, title, eventChange }) => (
  <React.Fragment>
    <p>{title}</p>
    <Select
      options={options}
      values={[]}
      valueField="id"
      labelField="name"
      onChange={(values) => eventChange(values)}
      searchable="true"
      autoFocus="true"
    />
  </React.Fragment>
);

GenresDropDownComponent.propTypes = {};

export default GenresDropDownComponent;
